module.exports = [
  require('./abjurer'),
  require('./alhoon'),
  require('./annis_hag'),
  require('./apprentice_wizard'),
  require('./archdruid'),
  require('./archer'),
  require('./aurochs'),
]
